const Spinner = () => {
  return(
    <div className="spinner-border text-dark text-center"></div>
  );
};

export default Spinner;